import styled from 'styled-components'

export const StyledModalStatus = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 48px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 12px 0;
  width: 100%;
  margin-top: 15px;
  background: ${({ theme }) => theme.colors.primary};
  cursor: not-allowed;
`

export const StyledModalStatusIcon = styled.img`
  width: 28px;
  height: 28px;
`

export const StyledModalStatusText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #ffffff;
`
